import { Component, computed, input } from '@angular/core';
import { UmssIconComponent } from '../icon/icon.component';

/**
 * Inline "Verified" mark for manually verified credentials — a check circle plus
 * a label, in the primary accent.
 *
 * Deliberately NOT a pill badge. The Checkr background check renders a coloured
 * status pill ("Eligible / Clear") via UmssBackgroundCheckStatusBadgeComponent,
 * and a second pill next to it would read as the same class of automated,
 * provider-issued result. This is a manual, human-entered attestation, so it is
 * given a visually distinct treatment on purpose.
 */
@Component({
  selector: 'umss-verified-indicator',
  standalone: true,
  imports: [UmssIconComponent],
  templateUrl: './verified-indicator.component.html',
  styleUrl: './verified-indicator.component.scss'
})
export class UmssVerifiedIndicatorComponent {
  verified = input.required<boolean>();

  /** Label shown when verified. */
  verifiedLabel = input('Verified');

  /** Label shown when not verified. */
  unverifiedLabel = input('Not verified');

  size = input<'16px' | '20px'>('20px');

  protected readonly label = computed(() =>
    this.verified() ? this.verifiedLabel() : this.unverifiedLabel()
  );

  /**
   * A plain circle reads as an empty radio button — it looks like something the
   * viewer can click to change. Both states are circles carrying a mark so the
   * pair reads as one indicator rather than as a control.
   */
  protected readonly iconName = computed(() =>
    this.verified() ? 'phosphorCheckCircle' : 'phosphorXCircle'
  );
}
